module.exports = __webpack_public_path__ + "media/Images/ubiquity-logo-cabe64267579e1c265de75464b7615ab.png";